import { render, staticRenderFns } from "./EditPerson.vue?vue&type=template&id=69cd2988&scoped=true&"
import script from "./EditPerson.vue?vue&type=script&lang=js&"
export * from "./EditPerson.vue?vue&type=script&lang=js&"
import style0 from "./EditPerson.vue?vue&type=style&index=0&id=69cd2988&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd2988",
  null
  
)

export default component.exports